import { createApiClient } from '@aimsos/api-client';
import { tokenService } from '@aimsos/auth';

/**
 * HTTP client for the platform API, used by People & Access once its endpoints
 * exist. Every service in this folder is MOCK today (see `shared/utils/mockServiceHelpers.js`);
 * when a backend contract lands, a service swaps its seed for `platformApi.<verb>()`
 * and keeps the same `{ status_code, body, meta }` envelope.
 *
 * The client is lazy so `window.__AIMS_SHELL__` (set by `PeopleAccessEmbed`) is read on
 * the first request, not at module load. Embedded, it reuses the shell session — no
 * second Auth0 provider (embed contract).
 */
let client = null;

const readStored = (key) => {
  try {
    return localStorage.getItem(key) || undefined;
  } catch {
    return undefined;
  }
};

function resolveBaseUrl() {
  const shell = typeof window !== 'undefined' ? window.__AIMS_SHELL__ || {} : {};
  return String(shell.apiBaseUrl || import.meta.env.VITE_API_BASE_URL || '').replace(/\/+$/, '');
}

export const platformApi = new Proxy(
  {},
  {
    get(_, prop) {
      if (!client) {
        client = createApiClient({
          baseURL: resolveBaseUrl(),
          getToken: () => tokenService.getToken(),
          refreshToken: async () => {
            const userUuid = readStored('user_uuid');
            const tenantUuid = readStored('workspace_uuid');
            return tokenService.refreshToken(userUuid, tenantUuid);
          },
        }).client;
      }
      const value = client[prop];
      return typeof value === 'function' ? value.bind(client) : value;
    },
  },
);
